"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _clsx4 = _interopRequireDefault(require("clsx"));

var _themeProvider = require("@mmc/theme-provider");

var _close = _interopRequireDefault(require("../icons/close.svg"));

var _drawer = _interopRequireDefault(require("../styles/drawer.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var portalTargetNode = function () {
  if (typeof document !== 'undefined') {
    var container = document.createElement('div');
    container.id = 'mmc-drawer';
    document.querySelector('body').appendChild(container);
    return container;
  }
}();

var CommonDrawer = function CommonDrawer(_ref) {
  var _clsx, _clsx2, _clsx3;

  var children = _ref.children,
      contentClassName = _ref.contentClassName,
      _ref$isPopover = _ref.isPopover,
      isPopover = _ref$isPopover === void 0 ? false : _ref$isPopover,
      onClose = _ref.onClose,
      overlayClassName = _ref.overlayClassName,
      _ref$prerender = _ref.prerender,
      prerender = _ref$prerender === void 0 ? false : _ref$prerender,
      _ref$preventScroll = _ref.preventScroll,
      preventScroll = _ref$preventScroll === void 0 ? true : _ref$preventScroll,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;
  (0, _react.useEffect)(function () {
    if (preventScroll) {
      if (visible) {
        (0, _themeProvider.disableBodyScroll)();
      } else {
        (0, _themeProvider.enableBodyScroll)();
      }
    }
  }, [visible]);

  if (!portalTargetNode || !visible && !prerender) {
    return null;
  }

  var drawer = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(_drawer["default"].overlay, (_clsx = {}, _clsx[_drawer["default"].show] = visible, _clsx), overlayClassName),
    onClick: onClose,
    role: "presentation"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx4["default"])(_drawer["default"].content, (_clsx2 = {}, _clsx2[_drawer["default"].show] = visible, _clsx2), (_clsx3 = {}, _clsx3[_drawer["default"].popover] = isPopover, _clsx3), contentClassName)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _drawer["default"].closeIcon,
    src: _close["default"],
    alt: "close",
    onClick: onClose,
    role: "presentation"
  }), children));

  return /*#__PURE__*/(0, _reactDom.createPortal)(drawer, portalTargetNode);
};

var _default = CommonDrawer;
exports["default"] = _default;